import { Helmet } from "react-helmet-async";
import { SITE_URL } from "../../../constants/seo";

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "South Asia Consultancy Services Pvt. Ltd.",
  alternateName: "South Asia Consultancy",
  url: SITE_URL,
  logo: `${SITE_URL}/og-image.png`,
  description:
    "Integrated oilfield services partner delivering drilling, workover, maintenance, workforce, and oilfield project solutions.",
  email: "info@southasiaconsultancy.com",
  telephone: "+91-9316305258",
  sameAs: [
    "https://www.facebook.com/SouthAsiaConsultancy/",
    "https://www.linkedin.com/company/southasiaconsultancy/",
    "https://x.com/DSR_SOUTHASIA",
    "https://www.instagram.com/southasiaconsultancy/",
  ],
  address: [
    {
      "@type": "PostalAddress",
      streetAddress:
        "402, Orange Mall, Mehsana Highway, Above HDFC Bank, Nigam Nagar, Chandkheda",
      addressLocality: "Ahmedabad",
      addressRegion: "Gujarat",
      postalCode: "382424",
      addressCountry: "IN",
    },
    {
      "@type": "PostalAddress",
      streetAddress: "Saif Plus R6 - 11/B, P.O. Box 120197",
      addressLocality: "Sharjah",
      addressCountry: "AE",
    },
  ],
};

function OrganizationSchema() {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
    </Helmet>
  );
}

export default OrganizationSchema;
